<template>
  <div>
    <div class="row">
      <div class="col-sm-12 col-md-8">
        <form>
          <div class="form-group">
            <label for="ddlWeeks">How many weeks are in the schedule?</label>
            <select class="form-control" id="ddlWeeks" v-model="default_schedule.weeks">
              <option value="1">One Week</option>
              <option value="2">Two Weeks</option>
              <option value="3">Three Weeks</option>
            </select>
          </div>
          <div class="form-group">
            <label for="ddlWeeks">Schedule Start Date</label>
            <datepicker v-model="default_schedule.start_date" format="MM/dd/yyyy" inputClass="form-control" placeholder="Select Date"></datepicker>
          </div>
          <div class="alert alert-warning" role="alert">
            <b>Notice:</b> The default schedule is valid for one year, starting from the above date.
          </div>
          <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" data-toggle="tab" href="#weekOne" role="tab">Week One</a>
            </li>
            <li class="nav-item" v-show="default_schedule.weeks >= 2">
              <a class="nav-link" data-toggle="tab" href="#weekTwo" role="tab">Week Two</a>
            </li>
            <li class="nav-item" v-show="default_schedule.weeks >= 3">
              <a class="nav-link" data-toggle="tab" href="#weekThree" role="tab">Week Three</a>
            </li>
          </ul>
          <div class="tab-content">
            <div class="tab-pane fade show active" id="weekOne" role="tabpanel">
              <table class="table table-striped">
                <tbody>
                <tr
                  v-for="default_schedule_day in default_schedule_days_week_1"
                    :key="default_schedule_day.default_schedule_day_id">
                  <td>
                    {{ default_schedule_day.day_of_week_name }}
                  </td>
                  <td>
                    <select class="form-control" v-model="default_schedule_day.day_schedule_id">
                      <option value="0">None</option>
                      <option v-for="day_schedule in filtered_day_schedules" :key="day_schedule.day_schedule_id" v-bind:value="day_schedule.day_schedule_id">
                        {{ day_schedule.name
                        }}
                      </option>
                    </select>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="tab-pane fade" id="weekTwo" role="tabpanel" v-show="default_schedule.weeks >= 2">
              <table class="table table-striped">
                <tbody>
                <tr
                  v-for="default_schedule_day in default_schedule_days_week_2" :key="default_schedule_day.default_schedule_day_id">
                  <td>
                    {{ default_schedule_day.day_of_week_name }}
                  </td>
                  <td>
                    <select class="form-control" v-model="default_schedule_day.day_schedule_id">
                      <option value="0">None</option>
                      <option v-for="day_schedule in filtered_day_schedules"  :key="day_schedule.day_schedule_id" v-bind:value="day_schedule.day_schedule_id">
                        {{ day_schedule.name
                        }}
                      </option>
                    </select>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="tab-pane fade" id="weekThree" role="tabpanel" v-show="default_schedule.weeks >= 3">
              <table class="table table-striped">
                <tbody>
                <tr
                  v-for="default_schedule_day in default_schedule_days_week_3" :key="default_schedule_day.default_schedule_day_id">
                  <td>
                    {{ default_schedule_day.day_of_week_name }}
                  </td>
                  <td>
                    <select class="form-control" v-model="default_schedule_day.day_schedule_id">
                      <option value="0">None</option>
                      <option v-for="day_schedule in filtered_day_schedules" :key="day_schedule.day_schedule_id" v-bind:value="day_schedule.day_schedule_id">
                        {{ day_schedule.name
                        }}
                      </option>
                    </select>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <br>
          <button type="button" class="btn btn-hub-primary" @click="submit()">Submit</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      day_schedules: 'allDaySchedules',
      default_schedule: 'getDefaultSchedule',
      scoped_site_id: 'scopedSiteId'
    }),
    default_schedule_days_week_1: function () {
      return this.default_schedule.default_schedule_days.filter(day => day.week_num === 1)
    },
    default_schedule_days_week_2: function () {
      return this.default_schedule.default_schedule_days.filter(day => day.week_num === 2)
    },
    default_schedule_days_week_3: function () {
      return this.default_schedule.default_schedule_days.filter(day => day.week_num === 3)
    },
    filtered_day_schedules: function () {
      return this.day_schedules.filter(daySchedule => daySchedule.site_id === this.scoped_site_id)
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
    this.$store.dispatch('getDaySchedules')
    this.$store.dispatch('getDefaultSchedule')
  },
  components: { Datepicker },
  methods: {
    submit () {
      this.$store.dispatch('editDefaultSchedule', this.default_schedule)
    }
  }
}
</script>
